module.exports = __webpack_public_path__ + "img/icon.8c20edc7.png";